import { COMPANY_LOCATION, COMPANY_NAME } from '../constants';

function Footer() {
  return (
    <footer className="border-t-2 border-fd-ink bg-fd-ivory">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-5 py-8 text-sm font-semibold text-fd-stone md:flex-row md:items-center md:justify-between">
        <p>{COMPANY_NAME} source profile</p>
        <p>{COMPANY_LOCATION}</p>
      </div>
    </footer>
  );
}

export default Footer;
